/**
 * TypingIndicator Component
 * Shows animated dots when another user is typing
 */

import React from 'react';
import './TypingIndicator.css';

interface TypingIndicatorProps {
  userName?: string;
  className?: string;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ userName, className = '' }) => {
  return (
    <div className={`typing-indicator ${className}`}>
      {userName && <span className="typing-name">{userName}</span>}
      <span className="typing-text">is typing</span>
      <span className="typing-dots">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </span>
    </div>
  );
};

export default TypingIndicator;
